import { Component, inject } from '@angular/core';

import { LoadingService } from '../../core/services/loading/loading.service';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.html',
  styleUrl: './loading-indicator.scss',
})
export class LoadingIndicator {
  protected readonly loading = inject(LoadingService);
}
